var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPercent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.333 12.1668L11.6663 44.8335M20.9997 15.6668C20.9997 18.8885 18.388 21.5002 15.1663 21.5002C11.9447 21.5002 9.33301 18.8885 9.33301 15.6668C9.33301 12.4452 11.9447 9.8335 15.1663 9.8335C18.388 9.8335 20.9997 12.4452 20.9997 15.6668ZM46.6663 41.3335C46.6663 44.5552 44.0547 47.1668 40.833 47.1668C37.6113 47.1668 34.9997 44.5552 34.9997 41.3335C34.9997 38.1118 37.6113 35.5002 40.833 35.5002C44.0547 35.5002 46.6663 38.1118 46.6663 41.3335Z",
    stroke: "#232F3E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercent);
export default __webpack_public_path__ + "static/media/percent.6ceb53c29abbd984cf309dbe371ba898.svg";
export { ForwardRef as ReactComponent };